// Gentle parallax on community spotlight background image – uses GSAP ScrollTrigger
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function spotlightParallax() {
	function initSpotlightParallax() {
		const inner = document.querySelector('.community-spotlight__inner');
		const image = document.querySelector('.community-spotlight__image');
		if (!inner || !image) return;

		gsap.to(image, {
			y: '+=15%',
			ease: 'none',
			scrollTrigger: {
				trigger: inner,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
			},
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSpotlightParallax);
	} else {
		initSpotlightParallax();
	}
}
